import React, { useRef } from "react";
import { useDrag } from "react-dnd";

import {
    VARIAZIONE_DROP_TYPE,
    VariazioneNewDragItem,
} from "./gantt/schedulazioneGanttTypes";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { useTheme } from "@mui/material/styles";

const VariazioneSidebarCard = () => {
    const theme = useTheme();
    const ref = useRef<HTMLDivElement>(null);

    const dragItem: VariazioneNewDragItem = { type: VARIAZIONE_DROP_TYPE };

    const [{ isDragging }, drag] = useDrag(
        () => ({
            type: VARIAZIONE_DROP_TYPE,
            item: dragItem,
            collect: (monitor) => ({ isDragging: monitor.isDragging() }),
        }),
        []
    );

    drag(ref);

    return (
        <Card
            ref={ref}
            sx={{
                mb: 0.5,
                cursor: "grab",
                opacity: isDragging ? 0.4 : 1,
                borderStyle: "dashed",
                borderWidth: 2,
                borderColor: theme.palette.info.main,
                backgroundColor: theme.palette.info.light + "20",
                "&:hover": {
                    boxShadow: theme.shadows[3],
                },
            }}
        >
            <CardContent sx={{ py: 1, px: 1.5, "&:last-child": { pb: 1 } }}>
                <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                    <AddBoxOutlinedIcon sx={{ color: theme.palette.info.main }} />
                    <Stack>
                        <Typography variant="caption" fontWeight="bold" color="info.main">
                            Nuovo placeholder
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.6rem" }}>
                            Trascina su un giorno per modulare la disponibilità.
                        </Typography>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default VariazioneSidebarCard;
